module.exports = __webpack_public_path__ + "static/img/aranceles-minimos-rpa.17203ea.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aranceles-minimos-rpa.jpeg
// module id = ciH+
// module chunks = 9